import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { FormattedMessage } from '@flipster/i18n';
import { css } from '@flipster/styled-system/css';
import { numberFormatter } from '@flipster/utils/num';

import { adjustLeverageModalBunja } from '../state';

/** Text-only hint when Isolated is at its ceiling and Cross allows higher leverage. */
export const CrossLeverageNudge = () => {
  const { showCrossNudgeAtom, crossMaxAtom } = useBunja(adjustLeverageModalBunja);
  const showCrossNudge = useAtomValue(showCrossNudgeAtom);
  const crossMax = useAtomValue(crossMaxAtom);

  if (!showCrossNudge) return null;

  return (
    <p
      className={css({
        textAlign: 'right',
        textStyle: 'Text/M/Regular',
        color: 'content.accent.info',
      })}
    >
      <FormattedMessage
        id='Trade.r260806.Up_to_leverage_available_in_cross'
        values={{ leverage: `${numberFormatter(crossMax)}x` }}
      />
    </p>
  );
};
